import React from 'react';
import {
  Descriptions,
  Table,
  Tag,
} from 'UI';
import SectionBasePage from 'components/SectionBasePage';
import {
  Order,
  OrderItem,
  Product,
  ProductionItem,
  Tray,
} from 'constants/interface';
import {
  OrderProposalStatusEnum,
  OrderProductionStatusEnum,
  OrderOtherStatusEnum,
  OrderUnitDisplayMapping,
  ProductionItemStatusEnum,
  ProductionItemStatusDisplayMapping,
} from 'constants/order';
import { ProductTypeMapping } from 'constants/product';

import TableRowAction from './components/TableRowAction';

import {
  ClickableColumnWrapper,
  MainContainer,
  OrderDescriptions,
  TableContainer,
  TableHeader,
} from './style';

interface ProposalDetailProps {
  order: Order
}

const OrderOverview = ({
  order,
}: ProposalDetailProps): JSX.Element => {
  // const dispatch = useDispatch();
  // const remoteTotal = useSelector(remoteTotalSelector);

  // const orderItemsEntities = useSelector(orderItemsEntitiesSelector);
  // const orderItemsIds = useSelector(orderItemsIdsSelector);
  // const isRemoteLoading = useSelector(isLoadingOrderItemsSelector);

  // const orderItems = orderItemsIds.map((orderItemId) => {
  //   const entity = orderItemsEntities[orderItemId];
  //   if (!entity) return undefined;
  //   const tableOrderItem: OrderItem & {
  //     key?: string,
  //   } = {
  //     ...entity,
  //     key: entity.id,
  //   };
  //   return tableOrderItem;
  // }).filter((tableOrderItem) => !!tableOrderItem) as (OrderItem & { key: string})[];

  // // const [currentActiveAction, setCurrentActiveAction] = useState<number>();

  // const remoteFetch = (
  //   paginationData: GetOrderItemList,
  // ) => {
  //   dispatch(getOrderItemListAction({
  //     ...paginationData,
  //   }));
  // };
  // const pagination = usePagination<object>( // eslint-disable-line @typescript-eslint/ban-types
  //   remoteFetch,
  //   {
  //     filter: {
  //       status: undefined,
  //       order: order?.id,
  //     },
  //     order: 'descend',
  //   },
  // );

  // useEffect(() => {
  //   dispatch(cleanOrderItemsAction());
  // }, []);

  // useEffect(() => {
  //   pagination.updateTotal(remoteTotal);
  // }, [remoteTotal]);

  // // const sorter = (): number => 0;

  // const pageData = pagination.getInternal();

  // const orderTypeFilter = pageData.filter.type ?? null;
  // const orderStatusFilter = pageData.filter.status ?? null;

  const statusFilterList = [
    ...Object.values(OrderProposalStatusEnum),
    ...Object.values(OrderProductionStatusEnum),
    ...Object.values(OrderOtherStatusEnum),
  ];

  return (
    <SectionBasePage>
      <MainContainer>
        {/* General Order Details */}
        <OrderDescriptions
          bordered
        >
          <Descriptions.Item
            label="Cliente"
          >
            {order.client.name}
          </Descriptions.Item>
          <Descriptions.Item
            label="Localizacao"
          >
            {order.location?.name || '-'}
          </Descriptions.Item>
          <Descriptions.Item
            label="OS"
          >
            {order.seq}
          </Descriptions.Item>
        </OrderDescriptions>

        <TableContainer>
          <Table<Omit<OrderItem, 'order'>>
            rowKey="id"
            dataSource={order.items}
            // pagination={pageData}
            // loading={isRemoteLoading}
            showSorterTooltip={false}
            locale={{
              filterReset: 'Limpar',
              cancelSort: 'Clique para limpar ordenação',
              triggerAsc: 'Clique para ordem crescente',
              triggerDesc: 'Clique para ordem decrescente',
            }}
            components={{
              header: {
                wrapper: TableHeader,
              },
            }}
            // onChange={pagination.onTableChange}
            expandable={{
              // childrenColumnName: 'productionItems',
              expandRowByClick: true,
              expandedRowRender: ({ productionItems }) => (
                <Table<Omit<ProductionItem, 'orderItem'>>
                  rowKey="id"
                  dataSource={productionItems}
                  pagination={false}
                >
                  <Table.Column
                    title="Produto"
                    key="product"
                    dataIndex="product"
                    render={(product: Product) => (
                      `${product.variety.culture.name} ${product.variety.name}`
                    )}
                  />
                  <Table.Column
                    title="Bdj"
                    key="tray"
                    dataIndex="tray"
                    render={(tray: Tray) => (
                      `${tray.capacity}${tray.isHydroponic ? ' Hidro' : ''}`
                    )}
                  />
                  <Table.Column
                    title="Formação​"
                    key="type"
                    dataIndex="product"
                    render={(product: Product) => {
                      // const displayName = OrderTypeDisplayMapping[order.type].name;
                      const displayName = ProductTypeMapping[product.type];
                      return displayName;
                    }}
                  />
                  <Table.Column
                    title="Status"
                    key="status"
                    dataIndex="status"
                    render={(status: ProductionItemStatusEnum) => {
                      const displayName = ProductionItemStatusDisplayMapping[status].name;
                      return (
                        <Tag color={ProductionItemStatusDisplayMapping[status].color}>
                          {displayName}
                        </Tag>
                      );
                    }}
                  />
                  <Table.Column<ProductionItem>
                    title=""
                    key="id"
                    dataIndex="id"
                    width="150px"
                    render={(id: string, record) => (
                      <TableRowAction
                        productionItem={record}
                        // index={index}
                        // onVisibleChange={(visibleIndex) => setCurrentActiveAction(visibleIndex)}
                      />
                    )}
                  />
                </Table>
              ),
            }}
          >
            <Table.Column
              // title="Itens do pedido"
              key="product"
              dataIndex="productionItems"
              render={(
                productionItems: ProductionItem[],
                // orderItem: OrderItem,
                orderItem: OrderItem,
              ) => {
                // const date = new Date(createdAt);
                // const formattedDate = date.toLocaleDateString('pt-br');
                // const orderType = orderItem.order.type;
                // const scionProduct = productionItems
                //   .find((prodItem) => prodItem.type === ProductTypeEnum.SCION);
                let reducedOrderItemStatus:
                  ProductionItemStatusEnum = ProductionItemStatusEnum.CONFIRMED;
                const display = `
                ${orderItem.orderQuantity}
                ${OrderUnitDisplayMapping[orderItem.unit].namePlural}
                ${productionItems.reduce((str, prodItem, prodItemIndex) => {
                  const separator = prodItemIndex === 0 ? '' : '/';
                  const prodItemStr = `
                    ${str}
                    ${separator}
                    ${prodItem.product.variety.culture.name}
                    ${prodItem.product.variety.name}
                    ${prodItem.tray.capacity}${prodItem.tray.isHydroponic ? ' Hidro' : ''}
                  `;
                  // TODO: move to another function?
                  if (prodItem.status > reducedOrderItemStatus.valueOf()) {
                    reducedOrderItemStatus = prodItem.status;
                  }
                  return prodItemStr;
                }, '')}
                `;
                return (
                  <ClickableColumnWrapper>
                    {display}
                    <Tag color={ProductionItemStatusDisplayMapping[reducedOrderItemStatus].color}>
                      {ProductionItemStatusDisplayMapping[reducedOrderItemStatus].name}
                    </Tag>
                  </ClickableColumnWrapper>
                );
              }}
            />
            {/* <Table.Column
              title="Formação"
              key="type"
              dataIndex="order"
              filters={Object.values(OrderTypeEnum).map((orderType) => ({
                text: OrderTypeDisplayMapping[orderType].name,
                value: orderType,
              }))}
              filterMultiple={false}
              filteredValue={orderTypeFilter !== null ? [orderTypeFilter] : null}
              render={(order: Order) => {
                const displayName = OrderTypeDisplayMapping[order.type].name;
                return displayName;
              }}
            /> */}
            {/* <Table.Column
              title="Status"
              key="status"
              dataIndex="productionItems"
              filters={statusFilterList.map((statusType) => ({
                text: OrderStatusDisplayMapping[statusType].name,
                value: statusType,
              }))}
              filterMultiple={false}
              filteredValue={orderStatusFilter !== null ? [orderStatusFilter] : null}
              render={(order: Order) => {
                const displayName = OrderStatusDisplayMapping[order.status].name;
                return (
                  <Tag color={OrderStatusDisplayMapping[order.status].color}>
                    {displayName}
                  </Tag>
                );
              }}
            /> */}
            {/* <Table.Column<OrderItem>
              title=""
              key="action"
              dataIndex="id"
              render={(id: string, record) => {
                const actionButton = (
                  <TableRowAction
                    orderItem={record}
                    // index={index}
                    // onVisibleChange={(visibleIndex) => setCurrentActiveAction(visibleIndex)}
                  />
                );
                return actionButton;
              }}
            /> */}
          </Table>
        </TableContainer>
      </MainContainer>
    </SectionBasePage>
  );
};

export default OrderOverview;
